<app-tvshop-header [rendition]="rendition"
                   [titleKey]="'eos-tv-shop-ii.title.netflix-services-option-header-' + omapiId.toLowerCase()"></app-tvshop-header>

<div class="netflix-services-details product-detail-container">
  <div class="product-detail-content product-detail-content--center" #streamingbundleoption>

    <app-container>
      <img class="product-detail-container--logo" src="{{getLogoUrl}}" alt="netflix">

      <app-spacer [spacerSize]="30"></app-spacer>

      <div class="grid grid-2-cols">
        <div class="tile">
          <div class="content">
            <h3 [translate]="'eos-tv-shop-ii.title.streaming-bundle-option-netflix-standard'"></h3>
            <app-spacer [spacerSize]="20"></app-spacer>
            <ul>
              <li [translate]="'eos-tv-shop-ii.text.streaming-bundle-option-watch-two-screens'"></li>
              <li [translate]="'eos-tv-shop-ii.text.streaming-bundle-option-watch-full-hd-quality'"></li>
            </ul>
          </div>
        </div>

        <app-checkbox-card
          [id]="selectedTvShopEntertainmentPack.streamingOption[0].omapiid"
          [titleKey]="'eos-tv-shop-ii.title.streaming-bundle-option'"
          [descriptionKey]="'eos-tv-shop-ii.text.streaming-bundle-option'"
          [badgeCopyKey]="'eos-tv-shop-ii.badge.streaming-bundle-option'"
          (emitOnEnterPressed)="onToggleStreamingOption($event)"
          (emitOnBack)="onBack()"
          [x]="0"
          [y]="0"></app-checkbox-card>
      </div>

      <app-spacer [spacerSize]="60"></app-spacer>

      <div class="bundle-option">
        <div class="buttonContainer">
          <app-order-button *ngIf="selectedTvShopEntertainmentPack"
                            [x]="0"
                            [y]="1"
                            [pack]="selectedTvShopEntertainmentPack"
                            [ownerComponent]="componentName"
                            [buttonTextKey]="'eos-tv-shop-ii.btn.netflix-+-streamzplus-order-complete'"
                            (emitOnEnterPressed)="onEmitOrderProduct($event)"
                            (emitOnBack)="onBack()">
          </app-order-button>
        </div>
      </div>
    </app-container>

  </div>
</div>

<app-ordering-modal-manager [order]="order" #orderModal></app-ordering-modal-manager>
